import script from "./Annotator.vue?vue&type=script&setup=true&lang=js"
export * from "./Annotator.vue?vue&type=script&setup=true&lang=js"

import "./Annotator.vue?vue&type=style&index=0&id=3b15af9d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b15af9d"]])

export default __exports__